import { render, staticRenderFns } from "./CryptoPayment.vue?vue&type=template&id=1fcc0c9f"
import script from "./CryptoPayment.vue?vue&type=script&lang=js"
export * from "./CryptoPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Theme2DesktopDepositStep: require('/app/components/Theme2/Desktop/DepositStep.vue').default,CommonsNuxtImage: require('/app/components/Commons/NuxtImage.vue').default,CommonsAutoFormatTextField: require('/app/components/Commons/AutoFormatTextField.vue').default,CommonsCopyButton: require('/app/components/Commons/CopyButton.vue').default})
